/* eslint-disable */

import 'owl.carousel';
import skrollr from 'skrollr';
//import 'skrollr-menu';

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    $(document).ready(function(){
      var test;

      function checkErrorForm() {
        if($('.errFld').length) {
          $('.section-footer').addClass('err');
          $('.form-container').addClass('err');
          clearInterval(test);
        } else {
          $('.section-footer').removeClass('err');
          $('.form-container').removeClass('err');
        }
      }

      setTimeout(function() {
        $('#submit_button').click(function() {
          test = setInterval(checkErrorForm, 1000);
        });
      }, 1000);

      $('#tfa_51').change(function() {
        var val = $(this).val();

        if(val == 'tfa_79') {
          $('.form-container').addClass('show');
          $('#tfa_268').addClass('show');
          $('#10-A').addClass('show');
          $('.section-footer').addClass('show');
        } else {
          $('.form-container').removeClass('show');
          $('#tfa_268').removeClass('show');
          $('#10-A').removeClass('show');
          $('.section-footer').removeClass('show');
        }
      });

      //initiate tooltip
      $('[data-toggle="tooltip"]').tooltip({container: 'body'});

      $('.hero-carousel').owlCarousel({
        items: 1,
        loop: true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        mouseDrag: false,
        onInitialized: callback,
      });

      function callback(event) {
        var items = event.item.count;
        if (items <= 1) {
          $('.owl-carousel').addClass("single");
        }
      }

      $('#retire-age').val(0);

      var el, newPoint, newPlace, offset, width;

      $('input[type=range]').on('input', function () {
        $(this).trigger('change');
      });
      // Select all range inputs, watch for change
      $("input[type='range']").change(function() {

            // Cache this for efficiency
            el = $(this);

            // Measure width of range input
            width = el.width();

            // Figure out placement percentage between left and right of input
            newPoint = (el.val() - el.attr("min")) / (el.attr("max") - el.attr("min"));

            offset = -1;

            // Prevent bubble from going beyond left or right (unsupported browsers)
            if (newPoint < 0) { newPlace = 0; }
            else if (newPoint > 1) { newPlace = width; }
            else { newPlace = width * newPoint + offset; offset -= newPoint; }

            if(newPlace > 125) {
              offset = -3;
            }

            if(newPlace > 216) {
              offset = -5;
            }

            if(newPlace > 343) {
              offset = -6;
            }

            // Move bubble
            el
                .next("output")
                .css({
                  left: newPlace,
                  marginLeft: offset + "%",
                })
                .text(el.val());

          //console.log(newPlace);
          })
          // Fake a change to position bubble at page load
          .trigger('change');

      $('.testimonial-carousel').owlCarousel({
        items: 1,
        loop: true,
        nav: true,
        autoplay:true,
        autoplayTimeout:5000,
        autoplayHoverPause:true,
        navText: ['<div class="arrow-left"></div>','<div class="arrow-right"></div>'],
      });

      var all_pos = [];

      function setup_first_slide_link() {
        var slide1_year = $('.skrollr-link').eq(0).data('year');
        var slide1_position = $('.skrollr-link').eq(0).data('position');

        $('.timeline-start').attr('data-year', slide1_year);
        $('.timeline-start').attr('data-position', slide1_position);
      }

      function init_skrollr() {
        skrollr.init();

        //get scroll position for nav links
        $.each($('.slide.skrollable'), function() {
          var i = 1;
          $.each($(this).data(), function(key) {
            if(i % 4 == 0) {
              all_pos.push([key]);
            }
            i++;
          });
        });

        var counter = 0;
        $.each($('a.skrollr-link'), function() {
          //if (counter > 0) {
            $(this).attr('data-position', all_pos[counter]);
          //}
          counter++;
        });

        setup_first_slide_link();
      }

      if( $('.history').length ) {
        if ($(window).width() > 767) {
          init_skrollr();

          $('.timeline-start').click(function(e){
            e.preventDefault();
            $('#slide-nav .skrollr-link:first-child').click();
          });
        }

        // disable skrollr if the window is resized below 768px wide
        $(window).on('resize', function () {
          if ($(window).width() <= 767) {
            skrollr.init().destroy(); // skrollr.init() returns the singleton created above
          } else {
            init_skrollr();
          }
        });

        //Control the menu
        $('a[href^="#"]').click(function(e) {
          e.preventDefault();

          var target = this.hash,
              $target = $(target),
              point;

          if ($(this).hasClass('skrollr-link')) {
            if ($(window).width() > 767) {
              point = parseInt($(this).data('position'));
            } else {
              point = $target.offset().top;
            }

            $('html,body').animate({
              scrollTop: point,
            }, 900);
          } else {
            if (target == '#join-us-section' && $target.length !== 1) {
              var getUrl = window.location.origin;

              window.location.href = getUrl + '/' + target;
            }

            if ($(this).hasClass('timeline-start')) {
              if ($(window).width() > 767) {
                point = parseInt($(this).data('position'));
              } else {
                point = $target.offset().top;
              }
            } else {
              point = $target.offset().top;
            }

            $('html,body').animate({
              scrollTop: point,
            });
          }

          //return false;
        });
      } else {
        $('a[href^="#"]').click(function(e) {
          e.preventDefault();

          var target = this.hash,
              $target = $(target),
              point;

          if($(this).attr('role') !== 'tab') {

            if($(this).hasClass('expand') == false) {

              if ($(window).width() > 767) {
                if (target == '#join-us-section' && $target.length !== 1) {
                  var getUrl = window.location.origin;

                  window.location.href = getUrl + '/' + target;
                }
                point = $target.offset().top;
              }

              //console.log($target, point);

              $('html,body').animate({
                scrollTop: point,
              });
            }
          }
          //return false;
        });
      }

      $(document).on('scroll', function(){
          var scroll = $(window).scrollTop();

          if(scroll >= 500) {
              $('.btn-top').show();
              //console.log(scroll);
          }else {
              $('.btn-top').hide();
          }

        if( $('.history').length ) {

           //var a = 0;
           //var patokan = all_pos[$a];
           //var lengthOfArr = all_pos.length;

          // Active state on scroll
          var prev_year = 0;
          //console.log(prev_year);

          var active = $('.slide.skrollable').filter( function() {
            return $(this).attr("active") > 0.70;
          });

          var year = active.data('year');

          if(year !== prev_year && year !== undefined) {
            $('.skrollr-link').removeClass('active');
            $('.skrollr-link[data-year="'+year+'"]').addClass('active');
            prev_year = year;
            //console.log(active);
            //console.log(prev_year, year, 'ui', $('.skrollr-link[data-year="'+year+'"]'));
          }

          //console.log(year);
          if(active.find('.right').length !== 0) {
            $('.skrollr-link').addClass('grey-color');
          } else {
            $('.skrollr-link').removeClass('grey-color');
          }

          if(year == undefined) {
            $('.skrollr-link').removeClass('active');
            $('.skrollr-link').removeClass('grey-color');
            prev_year = 0;
          }
        }
      });

      /*----------  Deeplink Tabs  ----------*/

      $(document).ready(() => {
        let url = location.href.replace(/\/$/, "");

        if (location.hash) {
          const hash = url.split("#");
          $('#about-tabs a[href="#'+hash[1]+'"]').tab("show");
          url = location.href.replace(/\/#/, "#");
          history.replaceState(null, null, url);
          setTimeout(() => {
            $(window).scrollTop(0);
          }, 400);
        }

        $('a[data-toggle="tab"]').on("click", function() {
          let newUrl;
          const hash = $(this).attr("href");
          if(hash == "#tab-1-content") {
            newUrl = url.split("#")[0];
          } else {
            newUrl = url.split("#")[0] + hash;
          }
          newUrl += "/";
          history.replaceState(null, null, newUrl);
        });
      });

      // $(function () {
      //   $('[data-toggle="popover"]').popover()
      // });

      /* ACCORDION TOGGLE */
      $('.expand').click(function(){
        var accorbox = $('.btn-accordion');

        if($(this).text() === '[+] Expand All') {
          $(this).text('[-] Collapse All');

          accorbox.each(function(index) {
            var that = this;
            if(index > 1) {
              index = 1;
            }

            setTimeout(function() {
              var id = $(that).data('target');

              if($(that).hasClass('collapsed')) {
                $(id).collapse('toggle');
              }
            }, 200 * index);
          });
        } else {
          $(this).text('[+] Expand All');
          accorbox.each(function(index) {
            var that = this;
            if(index > 1) {
              index = 1;
            }

            setTimeout(function() {
              var id = $(that).data('target');

              if($(this).hasClass('collapsed') == false) {
                $(id).collapse('toggle');
              }
            }, 200 * index);
          });
        }
      });
    });

    $(window).load(function(){
      showTarget(window.location.hash);
    });

    function showTarget(target) {
      target = target.replace('#', '');
      if (target) {
        $('html, body').animate({scrollTop: $('#' + target).offset().top}, 700, 'swing', function() {
          window.location.hash = '#' + target;
        });
      }
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js